import { graphql, HttpResponse } from 'msw'
import { type EnrollmentHYCSHomeData, type EnrollmentHYCSHomeSubmitOutput } from '../../../../models'

export const getEnrollmentHYCSHomeDataMock: EnrollmentHYCSHomeData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/get-started',
}

export const submitEnrollmentHYCSHomeDataMock: EnrollmentHYCSHomeSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/step-2',
}

export const mockGetEnrollmentHYCSHomeData = graphql.mutation('getEnrollmentHYCSHomeData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentHYCSHomeDataMock } })
})

export const mockSubmitEnrollmentHYCSHomeData = graphql.mutation('submitEnrollmentHYCSHomeData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentHYCSHomeDataMock } })
})

export const mockEnrollmentHYCSHome = [mockGetEnrollmentHYCSHomeData, mockSubmitEnrollmentHYCSHomeData]
